import React from "react";
import { Icon } from "@iconify/react";
import locationIcon from "../../../assets/location.svg";
export function EmptyAddress({ onAddClicked }) {
    return (React.createElement("div", { className: "py-4 pb-2 max-w-lg mx-auto" },
        React.createElement("div", { className: "flex flex-col gap-2 px-8" },
            React.createElement("div", { className: "w-full flex justify-center" },
                React.createElement("img", { alt: "location.svg", src: locationIcon })),
            React.createElement("div", { className: "w-full text-lg text-center" }, "You don't have any address added"),
            React.createElement("div", { className: "w-full text-sm text-center text-dark-gray pb-4" }, "Add your address!"),
            React.createElement("button", { className: "bg-primary rounded-xl p-3", onClick: onAddClicked },
                React.createElement("div", { className: "flex justify-center gap-2 text-secondary" },
                    React.createElement(Icon, { icon: "lucide:plus", width: "24", height: "24" }),
                    React.createElement("div", null, "Add New Address"))))));
}
